import { render, staticRenderFns } from "./PopupDefault.vue?vue&type=template&id=574c0200&"
import script from "./PopupDefault.vue?vue&type=script&lang=js&"
export * from "./PopupDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports